/**
 * @author Tim
 * @date 2024-01-05
 */

import {getHeaders} from "@/lib/storage.js"
import tool from "@/lib/tool.js"
import store from "@/lib/store.js"
let isRelogining = false
let waitRequest = []

/**
 * @description 发起 HTTP 请求
 * @param {object} config - 请求配置
 * @returns {Promise} - Promise 对象
 */
export function https(config) {
	
	return new Promise((resolve, reject) => {
		let urlTem = config.url
		// 请求头
		config.header = getHeaders();
		config.url = process.uniEnv.baseUrl + config.url;

		// 显示loading提示
		if(config.showLoading) tool.loading.show();
		
		uni.request(config)
			.then(res => {
				// 隐藏loading提示
				tool.loading.hide();
				if (res.statusCode === 200) {
					const data = res.data
					
					// 报错提示
					if(data.code === 7) {
						// 处理API限制错误，隐藏具体API路径
						let errorMsg = data.msg || data.message || "操作失败";
						if (errorMsg.includes('已达到接口')) {
							errorMsg = "查询次数已达到限制，请稍后再试";
							// 不显示toast，因为已经有modal提示
						} else {
							// 只有非API限制错误才显示toast
							tool.toast.show(errorMsg);
						}
					}

					// 判断是否自动登录(微信小程序和支付宝小程序)






































					















					

					try{
						console.log("H5",data)
						if(data.code === 7 && (data.message && data.message.includes('登录') || data.msg && data.msg.includes('登录'))){
							// 自动登录，不再跳转
							console.log('自动登录中...');
							relogin().then(res2 => {
								if(res2.code == 0) {
									console.log('自动登录成功');
								}
							});
						}
					}catch(e){
						//TODO handle the exception
					}

					
					resolve(data);
				} else {
					reject(new Error(`请求失败: ${JSON.stringify(res)}`));
				}
			})
			.catch(error => {
				// 隐藏loading提示
				tool.loading.hide();
				reject(error);
			});
	});
}

function relogin(){
	return new Promise((resolve,reject) => {
		let provider = ''
		let url = ''









		// H5环境使用新的微信公众号登录管理器
		console.log('🔄 H5环境：使用微信H5认证管理器重新登录...');
		
		// 动态导入微信H5认证管理器
		import('@/lib/wechat-h5-auth-manager.js').then(authManager => {
			const manager = authManager.default;
			
			// 确保在微信环境中
			if (!manager.isWechatBrowser()) {
				console.log('❌ 非微信环境，H5重新登录失败');
				resolve({ code: -1, message: '需要在微信中打开' });
				return;
			}
			
			manager.autoLogin().then(success => {
				if (success) {
					console.log('✅ H5微信重新登录成功');
					resolve({ code: 0, message: '登录成功' });
				} else {
					console.log('❌ H5微信重新登录失败');
					resolve({ code: -1, message: '登录失败，请重试' });
				}
			}).catch(error => {
				console.error('❌ H5微信重新登录异常:', error);
				resolve({ code: -1, message: error.message || '登录失败' });
			});
		}).catch(error => {
			console.error('❌ 微信H5认证管理器导入失败:', error);
			resolve({ code: -1, message: '登录模块加载失败' });
		});
		return; // 直接返回，不执行下面的uni.login

		
		uni.login({
			provider: provider, // 微信登录
			success: function (loginRes) {
				// 获取用户信息
				uni.getUserInfo({
					success: function(userInfo) {
						// 构建请求数据
						const requestData = {
							code: loginRes.code,
							nickname: userInfo.userInfo.nickName || '',
							gender: userInfo.userInfo.gender || 0
						};
						
						uni.request({
							url: process.uniEnv.baseUrl + url,
							header: {
								"content-type": 'application/json',
								"x-app-code": process.uniEnv.appID
							},
							data: requestData,
							method:'POST',
							//请求成功后返回
							success: (res) => {
								if(res.data.code == 0){
									// 缓存信息，注意新的API响应字段
									uni.setStorageSync('TOKEN', res.data.data.token)
									uni.setStorageSync('TOKEN_TIME', Date.now()); // 记录token获取时间
									// 根据API响应结构保存用户信息
									const userData = res.data.data.member || res.data.data || {};
									uni.setStorageSync('USER_INFO', userData);
									// 更新Vuex状态
									store.commit('setUserInfo', userData);
									store.commit('setLoginStatus', true);
									resolve(res.data)
								}else{
									uni.clearStorageSync();
									// 自动登录失败，不跳转到登录页面
									console.log('自动登录失败');
									reject()
								}
								tool.loading.hide();
							},
							fail: (err) => {
								console.error('登录请求失败:', err);
								uni.clearStorageSync();
								// 自动登录失败，不跳转到登录页面
								console.log('自动登录请求失败');
								reject(err);
								tool.loading.hide();
							}
						});
					},
					fail: function(err) {
						// 如果获取用户信息失败，则只发送code
						uni.request({
							url: process.uniEnv.baseUrl + url,
							header: {
								"content-type": 'application/json',
								"x-app-code": process.uniEnv.appID
							},
							data: { code: loginRes.code },
							method:'POST',
							success: (res) => {
								if(res.data.code == 0){
									uni.setStorageSync('TOKEN', res.data.data.token)
									uni.setStorageSync('TOKEN_TIME', Date.now()); // 记录token获取时间
									// 根据API响应结构保存用户信息
									const userData = res.data.data.member || res.data.data || {};
									uni.setStorageSync('USER_INFO', userData);
									// 更新Vuex状态
									store.commit('setUserInfo', userData);
									store.commit('setLoginStatus', true);
									resolve(res.data)
								}else{
									uni.clearStorageSync();
									// 自动登录失败，不跳转到登录页面
									console.log('自动登录失败');
									reject()
								}
								tool.loading.hide();
							},
							fail: (err) => {
								console.error('登录请求失败:', err);
								uni.clearStorageSync();
								// 自动登录失败，不跳转到登录页面
								console.log('自动登录请求失败');
								reject(err);
								tool.loading.hide();
							}
						});
					}
				});
			},
			fail: function(err) {
				console.error('微信登录失败:', err);
				uni.clearStorageSync();
				// 自动登录失败，不跳转到登录页面
				console.log('自动登录失败');
				reject(err);
				tool.loading.hide();
			}
		});
	});
}

/**
 * @description 发起 GET 请求
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @returns {Promise} - Promise 对象
 */
export function get(url, params, showLoading = true) {
	return https({
		method: 'GET',
		url,
		data: params,
		showLoading
	});
}

/**
 * @description 发起 POST 请求
 * @param {string} url - 请求地址
 * @param {object} data - 请求数据
 * @returns {Promise} - Promise 对象
 */
export function post(url, data, showLoading = true) {
	return https({
		method: 'POST',
		url,
		data,
		showLoading
	});
}

/**
 * @description 发起 PUT 请求
 * @param {string} url - 请求地址
 * @param {object} data - 请求数据
 * @returns {Promise} - Promise 对象
 */
export function put(url, data, showLoading = true) {
	return https({
		method: 'PUT',
		url,
		data,
		showLoading
	});
}

/**
 * @description 发起 DELETE 请求
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @returns {Promise} - Promise 对象
 */
export function del(url, params, showLoading = true) {
	return https({
		method: 'DELETE',
		url,
		data: params,
		showLoading
	});
}